import { Component, Inject, NgModule, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormsModule, FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { HttpClient } from '@angular/common/http';
import { CommonService } from '../../service/common.service';
import { Lavorazione } from '../../models/lavorazione';
import { Statolavorazione } from '../../models/statolavorazione';
import { Commessa } from '../../models/commessa';
import { Tipolavorazione } from '../../models/tipolavorazione';
import { configurazione } from '../../../configurazioni/configurazione';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Lavorazionearticolo } from '../../models/lavorazionearticolo';
import { Articolo } from '../../models/articolo';

@Component({
  selector: 'app-add-notacommessa-dialog',
  templateUrl: './add-notacommessa-dialog.component.html',
  styleUrls: ['./add-notacommessa-dialog.component.css'],
 
})
export class AddNotacommessaDialogComponent implements OnInit {
 
  commessa: Commessa = new Commessa();
  codice: number;
  noteamministrazione: string;
  
  hide = true;
 
  rc: number;
  registerForm: FormGroup;
  submitted = false;

  sortedDirection:Map<string, boolean>=new Map<string, boolean>();
 
  

  constructor(
    private commonService: CommonService,
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<AddNotacommessaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // Se ci sono dati passati al dialog, inizializza la commessa
    if (data) {
      this.codice = data.codice;
      this.noteamministrazione = data.noteamministrazione;
    }
  }

  ngOnInit(): void {
    if (this.registerForm === undefined) {
      this.registerForm = this.formBuilder.group({
        Codice: [this.codice, Validators.required],
        Noteamministrazione: [this.noteamministrazione]
      });
    }

  }


  aggiornaForm() {
    this.registerForm.setValue({
      Codicecommessa: this.codice,
      Noteamministrazione: this.noteamministrazione
    });
  }




  get f() { return this.registerForm.controls; }

  onAnnulla(): void {
    this.dialogRef.close();
  }

  onSalva(): void {

    
    this.submitted = true;

    // stop here if form is invalid
    if (this.registerForm.invalid) {
      alert("Errore: verifica i campi indicati con *");
      return;
    }


    this.commonService.saveNoteamministrazione(this.registerForm.value).subscribe(data => {
      this.rc=Number(data.status); 
      if (this.rc==200){
       const commessadata = new FormData();
        commessadata.append('codice', this.codice.toString());
          this.commonService.toggleCommessa(commessadata).subscribe((response) => {
           
        });
      }else {
        alert("Errore salvataggio note");
     }
     this.dialogRef.close(this.registerForm.value);
   });

    
  }




  getConfigurazione() {
    return configurazione.addnotacommessa;
  }

  
}
